<template>
  <ls-table-layout>
    <div class="table-page-search-wrapper" slot="search">
      <a-form layout="inline" :labelCol="{ style: { width: '80px' } }">
        <a-row>
          <a-col :md="6" :sm="24">
            <a-form-item label="流程单号">
              <global-select
                ref="billNoSearchRef"
                searchParam="billNo"
                selectType="selectSearch"
                :value.sync="queryParams.billNo"
                requestApi="/mes/mesFlowPathHead/billNoBox"
                :selectItem="{ value: 'realValue', label: 'label' }"
                :setParams="{ 'desOrganizationCode': organizationCodeOrigin }"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="申请人">
              <global-select
                searchParam="jobCode"
                selectType="selectSearch"
                :value.sync="queryParams.applicant"
                requestApi="/mes/mesFlowPathHead/applicantBox"
                :selectItem="{ value: 'realValue', label: 'label' }"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="审批人">
              <global-select
                searchParam="jobCode"
                selectType="selectSearch"
                :value.sync="queryParams.nextHandlerUser"
                requestApi="/mes/mesFlowPathHead/applicantBox"
                :selectItem="{ value: 'realValue', label: 'label' }"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24" v-if="advanced">
            <a-form-item label="审批状态">
              <global-select
                :value.sync="queryParams.status"
                requestApi="/system/lookup/data/list"
                :selectItem="{ value: 'lookupCode', label: 'lookupValue' }"
                :setParams="{ lookupType: 'MES_JOB_APPROVAL_STATUS' }"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <span class="table-page-search-submitButtons">
              <a-button @click="handleQuery" type="primary">查询</a-button>
              <a-button @click="resetQuery" class="ml8">重置</a-button>
              <a @click="toggleAdvanced" class="ml8">
                {{ advanced ? '收起' : '展开' }}
                <a-icon :type="advanced ? 'up' : 'down'"/>
              </a>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <template v-slot:table>
      <div class="page-header-content">
        <!-- 表格 -->
        <ls-api-table
          ref="dataTable"
          :columns="columns"
          :tableProps="tableProps"
          rowKey="id"
          :scroll="{ fixScreen: true, x: 1000 }"
          :toolBox="{
                density: true, // 传入String时 初始化默认表格密度
                fullScreen: false,  // 是否需要全屏
                configKey: $TableKey.APPROVAL_PROCESS_LIST, // 表格方案配置唯一值
              }"
        >
          <template v-for="item in columns" :slot="item.dataIndex" slot-scope="{ text, record }">
            <div :key="item.dataIndex">
              <span v-if="item.type === 'text'">{{ text && $moment(text).format('YYYY-MM-DD HH:mm:ss') }}</span>
              <span v-else-if="item.type === 'routerLink'">
                <a v-if="([1, 2, 3, 4, 5].includes(Number(record.type))) && record.statusName !== '已撤回'" @click="handleDetail(record)">{{ text }}</a>
                <span v-else>{{ text }}</span>
              </span>
              <span v-else>{{ text }}</span>
            </div>
          </template>
        </ls-api-table>
      </div>
    </template>
  </ls-table-layout>
</template>

<script>
import { apiMesFlowPathHeadList } from '@/api/approval/approval-process'
import { generateLsTableResData } from '@/utils/util.js';
import cloneDeep from 'lodash.clonedeep'
import { mapState } from 'vuex'

export default {
  name: 'Process', // name要和rms配置菜单路由保存一致(首字母大写)
  components: {},
  computed: {
    ...mapState({
      cacheHistory: (state) => state.pageHistory.cashHistory,
      organizationCodeOrigin: (state) => state.user.organizationCode
    })
  },
  data () {
    return {
      // 表格配置
      tableProps: {
        requestApi: generateLsTableResData(apiMesFlowPathHeadList, true),
        pageCurrent: true
      },
      // 控制搜索展开
      advanced: true,
      // 查询参数
      queryParams: {
        billNo: undefined,
        applicant: undefined,
        nextHandlerUser: undefined,
        status: undefined
      },
      // 表格数据
      tableList: [],
      // 表格字段
      columns: [
        {
          title: '流程单号',
          dataIndex: 'billNo',
          scopedSlots: { customRender: 'billNo' },
          align: 'center',
          type: "routerLink"
        },
        {
          title: '表单名称',
          dataIndex: 'formName',
          align: 'center'
        },
        {
          title: '库存组织',
          dataIndex: 'desOrganizationNames',
          align: 'center',
          width: 200,
          ellipsis: true
        },
        {
          title: '状态',
          dataIndex: 'statusName',
          align: 'center'
        },
        {
          title: '申请人',
          dataIndex: 'realName',
          align: 'center'
        },
        {
          title: '申请时间',
          dataIndex: 'applyTime',
          scopedSlots: { customRender: 'applyTime' },
          width: 160,
          align: 'center',
          type: "text"
        },
        {
          title: '审批人',
          dataIndex: 'nextHandlerUser',
          align: 'center'
        },
        {
          title: '审批时间',
          dataIndex: 'updateTime',
          align: 'center'
        }
      ]
    }
  },
  created () {
    if (this.cacheHistory && this.cacheHistory[this.$route?.fullPath]) {
      this.queryParams = this.cacheHistory[this.$route?.fullPath]
    }
  },
  mounted () {
    this.onSearch()
  },
  methods: {
    // 跳转审批详情
    handleDetail (record) {
      switch (Number(record.type)) {
        case 1:
          this.$router.push({ name: `approval-process-detail`, query: { bpmBillNo: record.id } })
          break;
        case 2:
          this.$router.push({ name: `Reserve-plan-approval`, query: { bpmBillNo: record.billNo } })
          break;
        case 3:
          this.$router.push({ name: `approval-inventory-adjectment`, query: { bpmBillNo: record.id } })
          break;
        case 4:
        case 5:
          this.$router.push({ name: `WorkOrderChangeProcessDetail`, query: { bpmBillNo: record.id, detailType: record.type } }) // 考核交期变更审批详情
          break;
      }
    },
    // 表单搜索
    onSearch () {
      // 添加当前选择的组织，用于权限判断
      this.$refs.dataTable.searchParams = { desOrganizationCode: this.organizationCodeOrigin, ...this.queryParams };
      this.$store.commit('setCashHistory', { path: this.$route.fullPath, data: cloneDeep(this.queryParams) })
      this.$refs.dataTable.getData();
    },
    // 新增/修改框事件
    handleOk () {
      this.onSearch()
    },
    /** 搜索按钮操作 */
    handleQuery () {
      this.onSearch()
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParams = {
        billNo: undefined,
        applicant: undefined,
        nextHandlerUser: undefined,
        status: undefined
      }
      this.handleQuery()
      this.$refs.billNoSearchRef.handleSearch(''); // 流程单号
    },
    // 搜索框展开、收起
    toggleAdvanced () {
      this.advanced = !this.advanced
    }
  }
}
</script>

<style scoped lang="less"></style>
